export default __webpack_public_path__ + "static/toolkitHomeVp5-cb7e994c80793b70c3b671a8391e8dd1.png";